import Vue from 'vue'

// Register commonly used components
import SearchPanel from './searchpanel.vue'
import Ripple from './ripple.vue'
import PrimaryTabs from './primary-tabs.vue'
import SecondaryTabs from './secondary-tabs.vue'
import Tab from '@/basecomponents/tab.vue'
import Label from './label.vue'
import PortalLabel from './portallabel.vue'
import Text from './text.vue'
import NumberComponent from './number.vue'
import Input from './input.vue'
import DatePicker from './datepicker.vue'
import Upload from './upload.vue'
import Table from './table.vue'
import Select from './select.vue'
import Double from './double.vue'
import AutoComplete from './autocomplete.vue'
import Checkbox from './checkbox.vue'
import Dialog from './dialog.vue'
import Button from './button.vue'
import Password from './password.vue'
import Radio from './radio.vue'
import TextArea from './textarea.vue'
import ServerDom from './serverdom.vue'
import ArrowBox from './arrowbox.vue'
import PagedTable from './pagedtable.vue'
import CustomPagedTable from './custompagedtable.vue'
import FileReader from './filereader.vue'
import Sort from './sort.vue'
import Filter from './filter.vue'
import FilterText from './filtertext.vue'
import FilterBool from './filterbool.vue'
import Slider from './slider.vue'
import Expander from './expander.vue'
import PlusMinus from './plusminus.vue'
import Filters from './filters.vue'

import ProductLookup from './productlookup.vue'
import BillingCodeLookup from './billingcodelookup.vue'
import UserLookup from './userlookup.vue'
import StatusLookup from './statuslookup.vue'
import ResultLookup from './resultlookup.vue'
import DatesLookup from './dateslookup.vue'
import Lookup from './lookup.vue'
import ChannelLookup from './channellookup.vue'

import DeedLookup from './deedlookup.vue'
import RegNo from './regno.vue'
import SinglePanel from './singlepanel.vue'
import Popper from './popper.vue'
import EditCell from "@/components/editcell";
import datepickernative from "@/components/datepickernative.vue";
import Enumlookup from "@/components/enumlookup.vue";
import Namelookup from "./namelookup.vue";

Vue.component('m-editcell', EditCell);
Vue.component('m-popper', Popper)
Vue.component('m-singlepanel', SinglePanel)
Vue.component('m-searchpanel', SearchPanel)
Vue.component('m-ripple', Ripple)
Vue.component('m-primary-tabs', PrimaryTabs)
Vue.component('m-secondary-tabs', SecondaryTabs)
Vue.component('m-tab', Tab)
Vue.component('m-input', Input)
Vue.component('m-label', Label)
Vue.component('m-portal-label', PortalLabel)
Vue.component('m-text', Text)
Vue.component('m-number', NumberComponent)
Vue.component('m-datepicker', DatePicker)
Vue.component('m-datepicker-native', datepickernative)
Vue.component('m-upload', Upload)
Vue.component('m-table', Table)
Vue.component('m-pagedtable', PagedTable)
Vue.component('m-custom-pagedtable', CustomPagedTable)
Vue.component('m-select', Select)
Vue.component('m-autocomplete', AutoComplete)
Vue.component('m-checkbox', Checkbox)
Vue.component('m-dialog', Dialog)
Vue.component('m-button', Button)
Vue.component('m-password', Password)
Vue.component('m-radio', Radio)
Vue.component('m-textarea', TextArea)
Vue.component('m-serverdom', ServerDom)
Vue.component('m-arrowbox', ArrowBox)
Vue.component('m-filereader', FileReader)
Vue.component('m-filter', Filter)
Vue.component('m-filtertext', FilterText)
Vue.component('m-filterbool', FilterBool)
Vue.component('m-slider', Slider)
Vue.component('m-expander', Expander)
Vue.component('m-plusminus', PlusMinus)
Vue.component('m-sort', Sort)
Vue.component('m-filters', Filters)
Vue.component('m-regno', RegNo)
Vue.component('m-lookup', Lookup)
Vue.component('m-productlookup', ProductLookup)
Vue.component('m-billingcodelookup', BillingCodeLookup)
Vue.component('m-userlookup', UserLookup)
Vue.component('m-statuslookup', StatusLookup)
Vue.component('m-enumlookup', Enumlookup)
Vue.component('m-resultlookup', ResultLookup)
Vue.component('m-dateslookup', DatesLookup)
Vue.component('m-deedlookup', DeedLookup)
Vue.component('m-double', Double)
Vue.component('m-channellookup', ChannelLookup)
Vue.component('m-namelookup', Namelookup)

function setVisiblity(el, state, collapse) {
    el.style.visibility = state ? 'visible' : (collapse ? 'collapse' : 'hidden')
}

Vue.directive('visible', {
    bind(el, { value, modifiers }) {
        setVisiblity(el, value, modifiers.collapse)
    },
    update(el, { value, modifiers }) {
        setVisiblity(el, value, modifiers.collapse)
    }
})

Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el, binding) {
        // Focus the element either if value is undefined or it's true
        if (binding.value !== false)
            el.focus()
    }
})

Vue.directive('intoview', {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
        el.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
})